export default {
  title: 'Karar Destek Araçları',
  description: 'Estimator24, alıcıların, yatırımcıların ve emlak ajanslarının veri ve yapay zeka ile bilinçli kararlar almasına yardımcı olur.',
  features: {
    evaluation: 'Tek tıkla gayrimenkul değerlendirmesi',
    forecast: 'Yapay sinir ağları ile fiyat tahminleri',
    analytics: 'Bölge ve mahalle bazında pazar analizi',
    tools: 'Karşılaştırma ve filtreleme araçları'
  }
}